import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { getTncConsent } from '../../app/features/ebl/actions/eBLActions';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../app/features/template/store';



interface TncHandlerProps {
    country: string;
    language: string;
    module: string;
    linerId: string | number | null;
    termsAccepted: boolean;
    setTermsAccepted: (value: boolean) => void;
    onClickShowModal?:boolean;
    modalHeader?: React.ReactNode;
}

const TncHandler: React.FC<TncHandlerProps> = ({ country, language, module, linerId, termsAccepted, setTermsAccepted, onClickShowModal, modalHeader }) => {
    const { t } = useTranslation();

    const [headerText, setHeaderText] = useState<string | null>(''); 
    const [contentText, setContentText] = useState<string | null>('');
    const [tncUrl, setTncUrl] = useState<string | null>(null);
    const dispatch = useDispatch<AppDispatch>();
    const [tncDialog, setShowTncDialog] = useState(false);
    const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);


    const closeTncDialog = () => setShowTncDialog(false);
    const showTncDialog = () => setShowTncDialog(true);
    const toggleTermsAccepted = () => setShowTncDialog(true);


    useEffect(() => {
        const fetchTnC = async () => {
            try{

                const response = await dispatch(
                    getTncConsent({ partnerId: linerId, countryCode: country, module, language})
                ).unwrap();

                if (response) {
                    setHeaderText(response.headerText);
                    setContentText(response.consentText);
                    setTncUrl(response.tncUrl);
                    setIsCheckboxDisabled(false);

                    if (
                        (!response.headerText || response.headerText === '') &&
                        (!response.consentText || response.consentText === '') &&
                        (!response.tncUrl || response.tncUrl === null)
                    ) {
                        setTermsAccepted(true);
                        
                        
                    }

                } else {

                    setHeaderText("");
                    setContentText("");
                    setTncUrl(null);
                    setIsCheckboxDisabled(true);
                    setTermsAccepted(false);
                }

            }
            catch (error){

                setIsCheckboxDisabled(true);
                setTermsAccepted(false);
            }
        };

        if (linerId && country) {
            fetchTnC();
        }
    }, [country, linerId, module, language]);



    const handleClick = () => {
        if (tncUrl) {
            window.open(tncUrl, '_blank');
        } else {
            showTncDialog();
        }
    };

    const renderHeaderWithLink = (text: string) => {
        const match = text?.match(/\{(.+?)\}/);


        if (!match) return text;

        const [fullMatch, linkText] = match;


        const parts = text.split(fullMatch);

        return (
            <>
                {parts[0]}
                <a href="#" onClick={handleClick}>{linkText}</a>
                {parts[1]}
            </>
        );
    };

    const termsConditionHide =
        (headerText === '' || headerText === null) &&
        (contentText === '' || contentText === null) &&
        (tncUrl === '' || tncUrl === null) &&
        !isCheckboxDisabled; 



    return (
        termsConditionHide ? (<></>) :
            (<div>
                <div className='col-lg-12 mb-2'>
                    <Form.Group>
                        <Form.Check
                            type='checkbox'
                            checked={termsAccepted}
                            disabled={isCheckboxDisabled}
                            onChange={(e) => {
                                if(onClickShowModal){
                                    showTncDialog();
                                }else{
                                    setTermsAccepted(e.target.checked)
                                }
                            }
                            }
label={
    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>{renderHeaderWithLink(headerText ?? '')}</span>
      {isCheckboxDisabled && (
        <span style={{ color: 'red', fontSize: '0.85em' }}>
           {t('resource_message:termsAndConditionsDelAboveSelParty')}
        </span>
      )}
    </span>
  }
                        //onChange={onToggleGrantFrtInvAccess}
                        //disabled={disableFields}
                        />
                    
     
                    </Form.Group>
                </div>
                <Modal show={tncDialog} onHide={closeTncDialog} size='lg'>
                    <Modal.Header className='p-2 pb-1' closeButton>
                        {/* <Modal.Title>{t('resource_3:termsAndConditions')}</Modal.Title> */}
                        <Modal.Title>{modalHeader ?? t('resource_3:termsAndConditions')}</Modal.Title>

                    </Modal.Header>

                    <Modal.Body
                        style={{
                            overflow: 'auto',
                            fontSize: '12px',
                        }}
                    >
                        {/* <p>{contentText}</p> */}
                        {/* <div dangerouslySetInnerHTML={{ __html: contentText }} /> */}
                        <div dangerouslySetInnerHTML={{ __html: contentText ?? '' }} />

                        {onClickShowModal && (
                            <div className='col-lg-8 offset-2 mt-3 d-flex justify-content-center align-items-center'>
                                <Button
                                    variant='falcon-primary'
                                    size='sm'
                                    className='me-2'
                                    onClick={() => {
                                        setTermsAccepted(true);
                                        setShowTncDialog(false);
                                    }}
                                    disabled={isCheckboxDisabled}
                                >
                                    <FontAwesomeIcon icon={faSave} className='me-2' />
                                    {t('resource_1:agree')}
                                </Button>

                                <Button
                                    variant='falcon-danger'
                                    size='sm'
                                    onClick={() => {
                                        setTermsAccepted(false);
                                        setShowTncDialog(false);
                                    }}
                                    disabled={isCheckboxDisabled}
                                >
                                    <FontAwesomeIcon icon={faTimes} className='me-2' />
                                    {t('resource_1:disagree')}
                                </Button>
                            </div>
                        )
                        }
                    </Modal.Body>
                </Modal>
            </div>)
    );
};

export default TncHandler;
